import KeyValuesGrid from "@/components/KeyValuesGrid";
import { Strategy } from "@/types/types";

type Props = {
  strategies: Strategy[];
};

export default function StrategyTable({ strategies }: Props) {
  return (
    <KeyValuesGrid
      valuesClasses="flex-1"
      headers={strategies.map(({ type }) => type)}
      values={[strategies.map(({ notes }) => notes)]}
    />
  );
}
